import React, { useEffect } from "react";
import "./Player.scss";
import eventTracking from '../../utils/eventTracking';

function Player(props) {
  function play(e) {
    const allPlayers = document.querySelectorAll("audio");
    const audio = e.target.children[0];
    const chapter = props.file.split("_")[0];
    const clip = props.file.split("_")[1];
    const allClipsInChapter = document.querySelectorAll(`.chapter-${chapter} .player`).length;
    if (e.target.classList.contains('play') && audio) {
      audio.pause();
      e.target.classList.remove('play');
    } else if (!e.target.classList.contains('play') && audio) {
      if (allPlayers) {
        for (const player of allPlayers) {
          player.pause();
          player.parentElement.classList.remove('play');
          player.currentTime = 0;
        }
      }
      audio.play();
      e.target.classList.add('play');
      eventTracking(
        `Kapittel ${chapter}`,
        'Lyd',
        `${clip} av ${allClipsInChapter}`
      );      
    }
  }
  useEffect(() => {
    document.getElementById(props.file).onended = function () {
      document.getElementById(props.file).parentElement.classList.remove('play');
    };
  });
  return (
    <div className="player" onClick={play}>
      <audio
        id={props.file}
        src={require("../../assets/audio/" + props.file + ".mp3")}
      ></audio>
    </div>
  );
}

export default Player;
